module.exports = __webpack_public_path__ + "img/PREPAY.c231b340.png";